<script setup>
import PublicationTypeValues from '~/values/PublicationTypeValues.js'

const route = useRoute()
const { $axios, $dayjs } = useNuxtApp()
const type = route.params?.type
const dateId = route.params?.dateId || null

const isValidType = computed(() => {
  return PublicationTypeValues
    .getList()
    .some(publicationType => publicationType.value === type)
})

const { data } = await useAsyncData('getPublicationData', async () => {
  try {
    if (isValidType.value) {
      return null
    }
    const response = await useCustomFetch(`publication/${type}`).catch(error => {
      console.error('API Error:', error?.message)
      throw createError({
        statusCode: 500,
        statusMessage: error?.message,
      })
    })
    return response.data.value?.data
  }
  catch (error) {
    console.error('API Error:', error?.message)
    throw createError({
      statusCode: error.response?.status || 500,
      statusMessage: error?.message,
    })
  }
})

if (isValidType.value) {
  const typeLabel = PublicationTypeValues.get(type)?.label_plural
  const pageTitle = `Tickets de ${typeLabel}`
  const pageDescription = `Descubre las mejores ofertas en boletos para ${String(typeLabel).toLowerCase()} y más. Vive experiencias inolvidables con entradas 100% seguras. ¡No te lo pierdas!`
  useSeoMeta({
    title: pageTitle,
    ogTitle: pageTitle,
    description: pageDescription,
    ogDescription: pageDescription,
    twitterDescription: pageDescription
  })
}
else {
  if (data.value) {
    let pageTitle = `${data.value.title} tickets ${$dayjs(data.value.dates[0].start_date).format('YYYY')}`
    let pageDescription = data.value.description

    if (dateId) {
      if (data.value?.dates) {
        const dateSelected = Array.from(data.value?.dates).find(date => Number(date.id) === Number(dateId))
        const dateFormated = $dayjs(dateSelected?.start_date).format('dddd D [de] MMMM YYYY [a las] h:mm A')
        pageTitle = `${data.value.title} tickets para el ${dateFormated}`
        pageDescription = `Compra tus boletos para el ${dateFormated} en Tickea. ¡No te lo pierdas!`
      } else {
        navigateTo(type, {
          replace: true,
          redirectCode: 301
        })
      }
    }

    useSeoMeta({
      title: pageTitle,
      description: pageDescription,
      ogTitle: pageTitle,
      ogDescription: pageDescription,
      twitterDescription: pageDescription
    })
  }
}
</script>

<template>
  <PublicationTypeListPage v-if="isValidType" :type="type" />
  <PublicationDetailPage v-else-if="!isValidType && data" :publicationData="data" />
</template>

<style scoped></style>
